import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EmlakBildirimAPI extends BaseAPI {
    constructor() {
        const baseUrl =
            environment.API_URL + "EmlakBildirimleriListe";
        super(baseUrl);
    }

    getEmlakBildirimListe( sicilKodu: number, aktifPasif: number, ada?: number, parsel?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
        var request = new EmlakBildirimRequest( sicilKodu, aktifPasif, ada, parsel, mahalleKodu, caddeSokakKodu);
        return this.post("", request, false);
    }
}
export default new EmlakBildirimAPI();
class EmlakBildirimRequest {
    public sicilKodu: number;
    public AktifPasif: number;
    public ada?: number;
    public parsel?: number;
    public mahalleKodu?: number;
    public caddeSokakKodu?: number;

    constructor(sicilKodu: number, aktifPasif: number, ada?: number, parsel?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
        this.sicilKodu = sicilKodu;
        this.AktifPasif = aktifPasif;
        this.ada = ada;
        this.parsel = parsel;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
    }
}
export { EmlakBildirimRequest };
